<template>
  <div class="TrendComplaint">
    <mt-header :title="$t('投诉')" class="dl_header_white" fixed>
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>
    <div class="main-container">
      <div class="tc_head">
        <span>{{$t('投诉')}}</span><span class="nickname"> @ {{ trend_nickname? trend_nickname:$t('匿名用户')}}</span><span> {{$t('的动态')}}:</span>
      </div>
      <div class="tc_content">
        <p>{{$t('请选择你想要投诉的类型')}}</p>
        <ul class="complaint_type">
          <li  v-for="(item,index) in complaintType" :key="index" :item_id="item.id" @click="chooseType(item)"> {{item.subject}}</li>
        </ul>
      </div>
      <div  class="tc_btn">
        <mt-button type="primary" size="large" @click="submitBtn"> {{$t('提交')}}</mt-button>
      </div>

    </div>
  </div>
</template>

<script>
import {getJuBaoType, juBao} from "../../api/trend";
import {MessageBox} from "mint-ui";
export default {
  name: "ComplaintTrend",
  data() {
    return {
      trend_nickname: this.$route.query.user_nickname,
      trend_id: this.$route.query.trend_id,
      complaintType:[],
      chooseSubject: ''
    }
  },
  mounted() {
    this.getComplaintType()
  },
  methods: {
    goback: function () {
      this.$router.back();
    },
    getComplaintType: function () {
      const params = {
        lang:this.$store.state.language
      }
      getJuBaoType(params).then(res => {
        if (res.code == 1) {
          this.complaintType = res.data
        }
      })
    },
    chooseType: function (item){
      this.chooseSubject = item.subject
      console.log(this.chooseSubject)
    },
    submitBtn: function (){
      if(!this.chooseSubject){
        return MessageBox.alert(this.$t('请选择投诉类型！'), this.$t("提示"))
      }
      const params = {
        subject:this.chooseSubject,
        moment_id:this.trend_id
      }
      juBao(params).then(res => {
        if (res.code == 1) {
          MessageBox.alert(res.msg, this.$t("提示"))
          this.$router.back();
        }
        console.log(res)
      })
    },
  }
}
</script>

<style scoped>
.TrendComplaint{
  height: 100vh;
  background: #f6f6f6;
}
.main-container{
  margin-top: 50px;
}
.tc_head,.tc_content{
  padding: 10px 15px;
  background: #fff;
}
.nickname{
  color: #1e86db;
}
.tc_content{
  margin-top: 5px;
}
.complaint_type{
  width: 100%;
  display: grid;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill,100px);
  flex-wrap: wrap;

}
.complaint_type li{
  width: 90px;
  padding: 10px;
  background-color: #f6f6f6;
  margin-top: 10px;
  font-size: 14px;
  text-align: center;
  border-radius: 5px;
}
.complaint_type li:hover{
  background-color: #1e86db;
  color: #fff;
}
.complaint_type li:active{
  background-color: #1e86db;
  color: #fff;
}
.tc_btn{
  margin: 10px 15px;
}
/*.complaint_type li:nth-child(1),.complaint_type li:nth-child(4){*/
/*  float: left;*/
/*}*/
/*.complaint_type li:nth-child(3),.complaint_type li:nth-child(6){*/
/*  float: right;*/
/*}*/
</style>
